var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLayoutModule1 = function SvgLayoutModule1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("title", null, "layout-module-1"), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.75,
    y: 0.747,
    width: 9,
    height: 9,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.75,
    y: 14.247,
    width: 9,
    height: 9,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 14.25,
    y: 0.747,
    width: 9,
    height: 9,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 14.25,
    y: 14.247,
    width: 9,
    height: 9,
    rx: 1.5,
    ry: 1.5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLayoutModule1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "layout-module-1.14f91c262ecc83e905f6bd2677976743.svg";